import { FadeUp } from "./Reveal";
import { scrollToSection } from "@/hooks/useLenis";

export const Footer = () => (
  <footer className="px-6 md:px-12 pt-28 md:pt-40 pb-10 bg-[#0A0A0A] border-t border-white/5" data-testid="site-footer">
    <FadeUp>
      <button
        data-testid="footer-cta"
        onClick={() => scrollToSection("#book")}
        className="group block text-left w-full mb-24"
      >
        <p className="text-xs tracking-[0.4em] uppercase text-[#525252] mb-6">One date. One story. Yours.</p>
        <span className="font-serif font-light text-[11vw] md:text-[7vw] leading-[0.95] tracking-tighter text-[#F5F4F0] group-hover:opacity-70 transition-opacity duration-500">
          Let's make it <span className="font-accent italic text-[#C9A26B]">timeless.</span>
        </span>
      </button>
    </FadeUp>
    <div className="flex flex-col md:flex-row justify-between gap-8 border-t border-white/10 pt-8 text-xs tracking-[0.2em] uppercase text-[#525252]">
      <p data-testid="footer-brand">TapeShift Weddings — {new Date().getFullYear()}</p>
      <div className="flex gap-8">
        <a href="mailto:tapeshiftinfo@gmail.com" data-testid="footer-email" className="hover:text-[#C9A26B] transition-colors duration-300">Email</a>
        <a href="https://instagram.com/tapeshift_weddings" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="hover:text-[#C9A26B] transition-colors duration-300">Instagram</a>
        <a href="/gallery" data-testid="footer-gallery-link" className="hover:text-[#C9A26B] transition-colors duration-300">Client Gallery</a>
        <a href="/admin" data-testid="footer-admin-link" className="hover:text-[#C9A26B] transition-colors duration-300">Studio Login</a>
      </div>
    </div>
  </footer>
);
